import { LogOut } from "lucide-react"
import { NavLink, Outlet } from "react-router-dom"
import { useAuth } from "@/auth/AuthProvider"
import { cn } from "@/lib/format"

const UMGEBUNG = (import.meta.env.VITE_ENV as string | undefined) ?? "dev"

/** Kopf von ProDash mit Navigation; die Seiten bringen ihre eigenen Filterleisten mit. */
export function Rahmen() {
  const { user, signOut } = useAuth()
  const link = ({ isActive }: { isActive: boolean }) =>
    cn("rounded-md px-2.5 py-1.5 text-[13px] font-medium", isActive ? "bg-accent/10 text-accent-strong" : "text-ink2 hover:text-ink")
  return (
    <div className="min-h-screen">
      <header className="border-b border-hair/10 bg-surface">
        <div className="mx-auto flex max-w-[1260px] flex-wrap items-center gap-x-5 gap-y-2 px-4 py-2.5">
          <div className="flex items-center gap-2">
            <img src={`${import.meta.env.BASE_URL}favicon.svg`} alt="" className="h-6 w-6" />
            <span className="font-semibold">ProDash</span>
            {UMGEBUNG !== "prod" && (
              <span className="rounded bg-warn/30 px-1.5 py-0.5 font-mono text-[10.5px] uppercase tracking-wider text-ink">{UMGEBUNG}</span>
            )}
          </div>
          <nav className="flex flex-wrap gap-1" aria-label="Bereiche">
            <NavLink to="/" end className={link}>Übersicht</NavLink>
            <NavLink to="/auswertungen/betriebstagebuch" className={link}>Betriebstagebuch</NavLink>
            <NavLink to="/schicht" className={link}>Proben der Schicht</NavLink>
            <NavLink to="/stellen" className={link}>Stellenbesetzung</NavLink>
          </nav>
          <div className="ml-auto flex items-center gap-3 text-[12.5px] text-ink2">
            <span>{user?.name}</span>
            <button type="button" onClick={signOut} className="inline-flex items-center gap-1 hover:text-ink" title="Abmelden">
              <LogOut className="h-4 w-4" aria-hidden="true" /> Abmelden
            </button>
          </div>
        </div>
      </header>
      <Outlet />
    </div>
  )
}
